<template>
  <div>
    <div class="mb-12"></div>
    <NavigationDrawer />
    <router-view></router-view>
    <div class="footer footer-fixed-bottom">
      <Footer />
    </div>
  </div>
</template>
<script>
import NavigationDrawer from "@/views/Dashboard/NavigationDrawer.vue";
import Footer from "@/views/Dashboard/Footer.vue";

export default {
  components: {
    NavigationDrawer,
    Footer,
  }
};
</script>
<style>
.footer{
  margin-top:5rem !important;
  
}
</style>
